import { useState, useEffect } from 'react';
import { resizeObserverManager } from './ResizeObserverManager';

export const useIsOverflow = (ref: React.RefObject<HTMLElement>, callback?: (isOverflow: boolean) => void): boolean => {
  const [isOverflow, setIsOverflow] = useState<boolean>(false);

  useEffect(() => {
    const current = ref.current;
    if (!current) return;

    const trigger = () => {
      const hasOverflow = current.scrollWidth > current.clientWidth;

      setIsOverflow(hasOverflow);

      if (callback) callback(hasOverflow);
    };

    resizeObserverManager.observe(current, trigger);

    trigger();

    return () => {
      resizeObserverManager.unobserve(current);
    }
  }, [callback, ref, ref.current?.scrollWidth]);

  return isOverflow;
};